
/*
 * ! @chakra-ui/vue v0.10.2 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

var StringArray = [String, Array];
var SNA = [Number, String, Array, Object];
var StringNumber = [String, Number];

export { StringArray as S, SNA as a, StringNumber as b };
